import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronDown } from 'lucide-react';

const Navbar = ({ isScrolled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [productsDropdown, setProductsDropdown] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);
  const toggleProductsDropdown = () => setProductsDropdown(!productsDropdown);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass-effect py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="container flex items-center justify-between">
        <Link to="/" className="flex items-center" onClick={closeMenu}>
          <div className="flex items-center">
            <img 
              src="https://media.licdn.com/dms/image/v2/D4E0BAQHGMRq0cxudrw/company-logo_100_100/company-logo_100_100/0/1727091211440?e=1749081600&v=beta&t=28OoNw5xVIa6NRPMb9WDqA9psxpJaIaa9NoAETHhZ5Q" 
              alt="AMOGOTech Logo" 
              className="w-10 h-10 mr-2 rounded-full border-2 border-white shadow-lg"
            />
            <span className="text-xl font-bold text-white">AMOGO<span className="text-primary-500">Tech</span></span>
          </div>
        </Link>
        
        <nav className="hidden md:flex items-center space-x-8">
          <NavLink to="/" className={({ isActive }) => `font-medium transition-colors ${isActive ? 'text-primary-500 drop-shadow-[0_0_8px_rgba(92,30,231,0.7)]' : 'text-gray-300 hover:text-primary-500'}`}>Accueil</NavLink>
          <NavLink to="/about" className={({ isActive }) => `font-medium transition-colors ${isActive ? 'text-primary-500 drop-shadow-[0_0_8px_rgba(92,30,231,0.7)]' : 'text-gray-300 hover:text-primary-500'}`}>À propos</NavLink>
          <div className="relative group">
            <button onClick={toggleProductsDropdown} className="flex items-center font-medium text-gray-300 hover:text-primary-500 transition-colors">
              Produits <ChevronDown size={16} className="ml-1" />
            </button>
            <div className={`absolute left-0 mt-2 w-48 glass-effect rounded-md shadow-lg transition-all duration-200 ${productsDropdown ? 'opacity-100 visible scale-100' : 'opacity-0 invisible scale-95'}`}>
              <div className="py-1">
                <Link to="/products" className="block px-4 py-2 text-sm text-gray-300 hover:bg-primary-500/10 hover:text-primary-500">Tous les produits</Link>
                <Link to="/products#route-senegal" className="block px-4 py-2 text-sm text-gray-300 hover:bg-primary-500/10 hover:text-primary-500">Route Senegal</Link>
                {/* <Link to="/products#multichange" className="block px-4 py-2 text-sm text-gray-300 hover:bg-primary-500/10 hover:text-primary-500">Multichange</Link> */}
              </div>
            </div>
          </div>
          <NavLink to="/contact" className={({ isActive }) => `font-medium transition-colors ${isActive ? 'text-primary-500 drop-shadow-[0_0_8px_rgba(92,30,231,0.7)]' : 'text-gray-300 hover:text-primary-500'}`}>Contact</NavLink>
        </nav>

        <button className="md:hidden text-gray-300 focus:outline-none" onClick={toggleMenu} aria-label="Toggle menu">
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden glass-effect"
          >
            <div className="container py-4 space-y-4">
              <Link to="/" className="block py-2 font-medium text-gray-300 hover:text-primary-500" onClick={closeMenu}>Accueil</Link>
              <Link to="/about" className="block py-2 font-medium text-gray-300 hover:text-primary-500" onClick={closeMenu}>À propos</Link>
              <div>
                <button onClick={toggleProductsDropdown} className="flex items-center w-full py-2 font-medium text-gray-300 hover:text-primary-500">
                  Produits <ChevronDown size={16} className={`ml-1 transition-transform ${productsDropdown ? 'rotate-180' : ''}`} />
                </button>
                <AnimatePresence>
                  {productsDropdown && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.2 }}
                      className="pl-4 space-y-2 mt-2"
                    >
                      <Link to="/products" className="block py-2 text-gray-400 hover:text-primary-500" onClick={closeMenu}>Tous les produits</Link>
                      <Link to="/products#route-senegal" className="block py-2 text-gray-400 hover:text-primary-500" onClick={closeMenu}>Route Senegal</Link>
                      {/* <Link to="/products#multichange" className="block py-2 text-gray-400 hover:text-primary-500" onClick={closeMenu}>Multichange</Link> */}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
              <Link to="/contact" className="block py-2 font-medium text-gray-300 hover:text-primary-500" onClick={closeMenu}>Contact</Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;